export const getBrowserTimeZoneOffset = (): number => {
  const browserDate = new Date();
  const offset = browserDate.getTimezoneOffset();
  return offset;
};
